<template>
  <div class="confirm-layout">
    <div class="alert alert-success">
      此藥物總存量: {{ selectedDrugTotalAmount }} 
      <span class="float-right" v-if="perscription !== 0">處方籤數量: {{ perscription }}</span>
    </div>

    <ConfirmStorage 
      v-if="currentProgress === 'setFetchNum'" 
      :defaultAmount="defaultAmount" 
      :inputLabel="'處方籤數量'"
      v-on:setNum="getStorageAmount"/>

    <MedIdInput
      v-if="currentProgress === 'MedIdInput'"
      :inputLabel="textInpuTitle"
      v-on:setText="getMedId"
    />
   
    <rx-check-barcode v-if="currentProgress === 'rxCheck'" v-on:confirmRx="confirmRx" />

    <ActionWrap 
    v-if="currentProgress === 'actionWrap'" 
    v-on:setActionData="getFetchData"
    :startActionType="startActionType"
    :actionProgress="actionProgress"
    :medRecordId="medRecordId"
    :barcodeData="barcodeData"
    :reviewer="reviewer"
    :amount="perscription" />
  </div>
</template>


<script>
import ConfirmFlowBase from '../ComponentBase/ConfirmFlowBase';
import ConfirmStorage from '../flowComp/NumberSet';
import MedIdInput from '../flowComp/TextInput';
import ActionWrap from './ActionWrap';
import RxCheckBarcode from '../flowComp/RxCheckBarcode';

export default {
  name: 'ConfirmFlow',
  extends: ConfirmFlowBase,
  props: ['barcodeData', 'startActionType'],
  data() {
    return {
      perscription: 0,
      defaultAmount: 0,
      fetchData: [],
      medRecordId: '',
      reviewer: undefined,
    };
  },
  components: {
    ConfirmStorage,
    ActionWrap,
    MedIdInput,
    RxCheckBarcode,
  },
  methods: {
    confirmRx(reviewer) {
      this.reviewer = reviewer;
      this.nextProgress();
    },
    getStorageAmount(amount) {
      this.perscription = parseInt(amount, 10);
      if (this.perscription > this.selectedDrugTotalAmount) {
        this.$store.commit('SET_MESSAGE', { type: 'warn', context: '處方籤大於總存量，藥櫃存量將無法滿足取藥量' });
      }
      this.nextProgress();
    },
    getFetchData() {
      console.log('confirmation finished');
      this.$emit('confirmationFinish');
      this.resetProgress();
      this.perscription = 0; // reset perscription
    },
    getMedId(data) {
      console.log(data);
      this.medRecordId = data;
      this.$store.commit('SET_MED_RECORD_NO', data);
      if (data === '' || data === undefined) {
        this.$store.commit('SET_MESSAGE', { type: 'error', context: '病歷號不可以為空' });
      } else {
        this.nextProgress();
      }
    },
  },
  mounted() {
    this.$store.commit('SET_CURRENT_STEP', this.currentProgress);
    // barcode amount
    if (this.barcodeData.amount && this.currentProgress === 'setFetchNum') this.nextProgress();
    if (this.barcodeData.medRecordId && this.currentProgress === 'MedIdInput') this.nextProgress();
    if (this.barcodeData.amount) {
      this.perscription = this.barcodeData.amount;
      this.medRecordId = this.barcodeData.medRecordId;
    }

    if (this.$store.state.schedule.currentSchedule !== null) {
      this.medRecordId = this.$store.state.schedule.currentSchedule.patient.med_record_number;
    }
  },
  computed: {
    textInpuTitle() {
      if (this.startActionType === 'FETCH') return '輸入病歷號';
      if (this.startActionType === 'FETCH_TRANSFER') return '輸入本單編號';
      return '';
    },
  },
  watch: {
    confirmProgress(val) {
      // reset data for next flow
      if (val === 'setFetchNum') {
        this.perscription = 0;
        this.defaultAmount = 0;
        this.fetchData = [];
        this.medRecordId = '';
      }
    },
  },
};
</script>



// WEBPACK FOOTER //
// ConfirmFlow.vue?474e3a9c